// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Box from '@mui/material/Box'

import {
  isAdmin,
  isAuthenticated,
  logout,
  getLoginRedirectUrl
} from 'services/self'

import { cognitoDomain, cognitoClientId } from '../services/api'

// mobx
import { observer } from 'mobx-react-lite'

// fragments
import { fragments } from 'services/get-fragments'

// components
import MenuLink from 'components/MenuLink'
import { store } from 'services/state'

function getCognitoUrl (type) {
  const redirectUri = getLoginRedirectUrl()
  return `${cognitoDomain}/${type}?response_type=token&client_id=${cognitoClientId}&redirect_uri=${redirectUri}`
}

export const NavBar = observer(function NavBar () {
  const email = store.user && store.user.email

  return (
    <AppBar position='static' elevation={0} style={{ flex: '0 0 auto', backgroundColor: '#1b1c1d', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <Toolbar disableGutters variant='dense' style={{ display: 'flex', justifyContent: 'space-between', minHeight: '55px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
          <MenuLink to='/' sx={{ display: 'flex', alignItems: 'center', textTransform: 'none' }}>
            <img src='/custom-content/nav-logo.png' alt='logo' style={{ height: 30, paddingRight: 10 }} />
            {fragments.Home.title}
          </MenuLink>

          <MenuLink to='/getting-started'>{fragments.GettingStarted.title}</MenuLink>
          {isAuthenticated() && <MenuLink to='/apis' target='_blank'>{fragments.APIs.title}</MenuLink>}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
          {isAuthenticated() ? (
            <>
              {isAdmin() && <MenuLink to='/admin/accounts'>Admin Panel</MenuLink>}
              {/* {isRegistered() && <MenuLink to='/dashboard'>My Dashboard</MenuLink>} */}
              <MenuLink onClick={logout}>
                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                  {email && <span style={{ marginBottom: '.5rem' }}>{email}</span>}
                  <span>Sign out</span>
                </Box>
              </MenuLink>
            </>
          ) : (
            <MenuLink to={getCognitoUrl('login')}>Sign In</MenuLink>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  )
})

export default NavBar
